export class SurveyBase {
  title: string;
  description: string;
}
